import { inject, Injectable, Injector } from '@angular/core';

import { DialogRef, DialogService } from '@hglobal/fin-ui';

import { BaseDialogComponent } from '@zeusm/shared/common';
import { DialogData } from '@zeusm/shared/core/entities';
import { DialogStackService } from '@zeusm/shared/core/services';

@Injectable()
export class BusinessDialogService {
  readonly #dialogService = inject(DialogService);
  readonly #stack = inject(DialogStackService);

  open<T, V>(props: DialogData<T, V>, injector?: Injector): DialogRef {
    const ref = this.#dialogService.open(
      BaseDialogComponent,
      {
        ...props,
        width: 750,
      },
      { parentInjector: injector },
    );
    this.#stack.register(ref);

    return ref;
  }
}
